import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


// import { DragulaModule } from 'ng2-dragula';
// import { ClipboardModule } from 'ngx-clipboard';
// import { ContextMenuModule } from 'ngx-contextmenu';
// import { NouisliderModule } from 'ng2-nouislider';
// import { CarouselModule } from 'ngx-owl-carousel-o';
// import { DropzoneModule } from 'ngx-dropzone-wrapper';
// import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
// import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
// import { ColorPickerModule } from 'ngx-color-picker';
import {AngularDateTimePickerModule} from 'angular2-datetimepicker';
// import { AmazingTimePickerModule } from 'amazing-time-picker';
// import { TagInputModule } from 'ngx-chips';

// import { NgxSummernoteModule } from 'ngx-summernote';
// import { TinymceModule } from 'angular2-tinymce';
// import { AceEditorModule } from 'ng2-ace-editor';
// import { CodemirrorModule } from 'ng2-codemirror';
// import { ChartsModule } from 'ng2-charts';
// import { Select2Module } from 'ng2-select2';
// import { MorrisJsModule } from 'angular-morris-js';
// import { ChartistModule } from 'ng-chartist';
// import { DataTablesModule } from 'angular-datatables';

// import { ToastrModule } from 'ngx-toastr';
// import { AgmCoreModule } from '@agm/core';
// import { BarRatingModule } from "ngx-bar-rating";
// import { FullCalendarModule } from 'ng-fullcalendar';
// import { ScrollToModule } from 'ng2-scroll-to-el';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {SharedModule} from './modules/shared/shared.module';
import {NgCircleProgressModule} from 'ng-circle-progress';
import {LazyLoadImageModule, scrollPreset} from 'ng-lazyload-image';


// const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
//   // Change this to your upload POST address:
//    url: 'https://httpbin.org/post',
//    maxFilesize: 50,
//    acceptedFiles: 'image/*'
//  };

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        SharedModule.forRoot(),
        NgCircleProgressModule.forRoot({
            // set defaults here
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#78C000',
            innerStrokeColor: '#C7E596',
            animationDuration: 300,
            responsive: true
        }),
        // LazyLoadImageModule.forRoot({
        //     preset: scrollPreset // <-- tell LazyLoadImage that you want to use scrollPreset
        // }),
        LazyLoadImageModule,
        // NgbModule.forRoot(),
        // DragulaModule.forRoot(),
        // ClipboardModule,
        // ContextMenuModule.forRoot(),
        // NouisliderModule,
        // CarouselModule,
        // DropzoneModule,
        // ColorPickerModule,
        AngularDateTimePickerModule,
        // AmazingTimePickerModule,
        // TagInputModule,
        // NgxSummernoteModule,
        // TinymceModule.withConfig({}),
        // AceEditorModule,
        // CodemirrorModule,
        // ChartsModule,
        // Select2Module,
        // MorrisJsModule,
        // ChartistModule,
        // DataTablesModule,
        // SweetAlert2Module.forRoot(),
        // ToastrModule.forRoot(),
        // AgmCoreModule.forRoot({ apiKey: 'AIzaSyCnT63XUjqjPgXZ0lFTU_pdpfUX7swzTTM' }),
        // BarRatingModule,
        // FullCalendarModule,
        // ScrollToModule.forRoot(),
        AutocompleteLibModule
    ],
    providers: [
        // {
        //   provide: DROPZONE_CONFIG,
        //   useValue: DEFAULT_DROPZONE_CONFIG
        // }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
